export default "__VITE_ASSET__CmR2qWCz__"